export const minTransaction = 10000
export const transactionStatus = [
	{
		id: 1,
		name: 'campaign'
	},
	{
		id: 2,
		name: 'zakat'
	},
	{
		id: 3,
		name: 'infaq'
	},
	{
		id: 4,
		name: 'infak_sos'
	},
	{
		id: 5,
		name: 'zx_berbagi'
	},
	{
		id: 6,
		name: 'topup'
	}
]